import React from 'react';
import { Animated, StyleSheet } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';

// Theme-based gradient system that only renders when explicitly enabled
export const ThemeGradientOverlay = ({ 
  opacity = 0, 
  borderRadius = 0, 
  direction = 'horizontal',
  enabled = false 
}) => {
  // Only render if explicitly enabled AND opacity > 0
  if (!enabled || !opacity || opacity === 0) return null;
  
  return (
    <Animated.View 
      pointerEvents="none" 
      style={[
        StyleSheet.absoluteFillObject, 
        { 
          opacity, 
          borderRadius, 
          overflow: 'hidden' 
        }
      ]}
    >
      <LinearGradient
        colors={['rgba(255,255,255,0.0)', 'rgba(255,255,255,0.16)']}
        start={direction === 'horizontal' ? { x: 0, y: 0.5 } : { x: 0.5, y: 0 }}
        end={direction === 'horizontal' ? { x: 1, y: 0.5 } : { x: 0.5, y: 1 }}
        style={StyleSheet.absoluteFill}
      />
    </Animated.View>
  );
};

export const ThemeGlassBackground = ({ 
  opacity = 0, 
  borderRadius = 0,
  enabled = false 
}) => {
  // Only render if explicitly enabled AND opacity > 0
  if (!enabled || !opacity || opacity === 0) return null;
  
  return (
    <Animated.View 
      pointerEvents="none" 
      style={[
        StyleSheet.absoluteFillObject, 
        { 
          opacity, 
          borderRadius, 
          overflow: 'hidden' 
        }
      ]}
    >
      <LinearGradient
        colors={['rgba(0,0,0,0.0)', 'rgba(116,132,154,0.15)']}
        start={{ x: 0.5, y: 0 }}
        end={{ x: 0.5, y: 1 }}
        style={StyleSheet.absoluteFill}
      />
    </Animated.View>
  );
};
